import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=00a00f4d&"
import script from "./Overview.vue?vue&type=script&lang=ts&"
export * from "./Overview.vue?vue&type=script&lang=ts&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=00a00f4d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Overview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports